import sessionSlice from './slice/SessionSlice'
import userDataSlice from './slice/UseDataSlice'

import { configureStore } from "@reduxjs/toolkit"

const rootReducer = {
    session: sessionSlice,
    userData: userDataSlice,
}

const store = configureStore({reducer: rootReducer});

export default store
